import { createFeature, createReducer, on } from '@ngrx/store';

import { GreenHouseMap } from 'app/shared/features/map-row-selector/models';

import {
    resetSearchParams,
    updateGreenHouseMapFilters,
    updateGreenHouseMaps,
    updateRecentRowNumber,
} from './green-house-map.actions';
import {
    defaultSearchPrivaQueryParamsSearch,
    GreenHouseMapState,
    initialState,
} from './greenhouse-map.state';

export const greenHouseMapFeatureKey = 'greenHouseMap';

export const reducer = createReducer(
    initialState,
    on(updateGreenHouseMaps, (state, { greenHouseMapList }) => {
        // Actions of type 'loadGreenHouseMapsSuccess' are dispatched by master-data.service on a regular basis.
        // Here we check if the content for greenHouseMap list has changed. If not then the state does not change.
        // Otherwise, components consuming greenHouseMap list from the state will detect changes, and they will refresh
        // while it is not necessary. It will lead to unpredicted side effect. For example, the components
        // representing the greenHouseMap list will be destroyed and recreated again on every change of the state.
        const currentJson = JSON.stringify(sortGreenHouseMaps(state.greenHouseMapList));
        const newJson = JSON.stringify(sortGreenHouseMaps(greenHouseMapList));
        const listChanged = currentJson !== newJson;
        return listChanged
            ? {
                  ...state,
                  greenHouseMapList: [...greenHouseMapList],
              }
            : state;
    }),

    on(updateGreenHouseMapFilters, (state, { greenHouseMapFilters }): GreenHouseMapState => {
        if (greenHouseMapFilters === undefined) return state;
        return {
            ...state,
            greenHouseMapFilters: {
                ...state.greenHouseMapFilters,
                ...greenHouseMapFilters,
            },
        };
    }),
    on(updateRecentRowNumber, (state, { recentRowNumber }): GreenHouseMapState => {
        return {
            ...state,
            greenHouseMapFilters: {
                ...state.greenHouseMapFilters,
                recentRowNumber,
            },
        };
    }),
    on(resetSearchParams, (state): GreenHouseMapState => {
        return {
            ...state,
            greenHouseMapFilters: {
                ...state.greenHouseMapFilters,
                searchParams: defaultSearchPrivaQueryParamsSearch,
            },
        };
    }),
);

export const greenHouseMapFeature = createFeature({
    name: greenHouseMapFeatureKey,
    reducer,
});

function sortGreenHouseMaps(list: GreenHouseMap[]) {
    return [...list].sort((a, b) => a.number - b.number);
}
